var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-avatar',{attrs:{"size":_vm.size,"src":_vm.avatarSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }